import React from 'react';
import styles from './style.scss';
import { Form, FormDate } from 'jd-library';
import { connect } from 'react-redux';
import { handleOnChange } from '../../customActions';

const DateContainer = props => {
    const {
        s_dnm,
        userInput,
        s_mandatory,
        s_re_mandatory
    } = props.item;

    const getDateObj = (dateString) => {
        if(dateString)
        {
            var dateParts = dateString.split('/');
            // month is 0-based, that's why we need dataParts[1] - 1
            if(dateParts?.length > 1) {
                var dateObj = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
                return(dateObj);
            }else {
                return '';
            }
        }
    }

    return (
        <div className={styles['date-container']}>
            <Form>
                <FormDate
                    label={s_dnm}
                    iconClass='icon-calendarNew'
                    onDateChange={(event, obj, formattedDate) => {
                        props.handleOnChange({e: {
                                target: {value: formattedDate || ''},
                            },
                            parentIndex: props.parentIndex,
                            item: props.item,
                            isSellOnline: props.showSellOnline
                        })
                    }}
                    dateformat='dd/mm/yyyy'
                    isMobile={props.deviceData.isMobile}
                    variant='withMovingLabel'
                    startDate={getDateObj(userInput.value)}
                    crossIcon={true}
                    errorMessage={userInput.error}
                    infoMessage={'Required Field'}
                    labelOnTop={true}
                />
            </Form>
            {!userInput.error && (props.showSellOnline || props.isService ? s_mandatory =='1' : s_re_mandatory == '1') && !props.isAuditor && !props.session.viaOmni ? 
            <div className={styles['info-txt']}>
                Required Field
            </div> : ''}
        </div>
    )
};

const mapStateToProps = (state, props) => {
    return {
        ...props,
        item: state.productSpecification.editablePuvSpecAttributes[props.parentIndex],
        deviceData: state.library.deviceData,
        session: state.session,
        isService: state.products.editProduct.categoryType == 'service',
        isAuditor: state.session?.user?.loggedUser?.userType == "AUDITOR"
    }
}

const mapDispatchToProps = dispatch => {
    return {
        handleOnChange : payload => dispatch(handleOnChange(payload))
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(DateContainer);